import { JsonUtils } from "../../utils/json.util"
import { Position } from "./position"

export class Map {

    private _municipality: string | undefined
    private _state: string | undefined
    private _benign: number | undefined
    private _malignant: number | undefined
    private _in_analysis: number | undefined
    private _forms_count: number | undefined
    private _position: Position | undefined


    get municipality(): string | undefined {
        return this._municipality
    }

    set municipality(value: string | undefined) {
        this._municipality = value
    }
    get state(): string | undefined {
        return this._state
    }

    set state(value: string | undefined) {
        this._state = value
    }

    get benign(): number | undefined {
        return this._benign
    }

    set benign(value: number | undefined) {
        this._benign = value
    }


    get malignant(): number | undefined {
        return this._malignant
    }

    set malignant(value: number | undefined) {
        this._malignant = value
    }
    get in_analysis(): number | undefined {
        return this._in_analysis
    }

    set in_analysis(value: number | undefined) {
        this._in_analysis = value
    }
    get forms_count(): number | undefined {
        return this._forms_count
    }

    set forms_count(value: number | undefined) {
        this._forms_count = value
    }
     get position(): Position | undefined {
        return this._position
    }

    set position(value: Position | undefined) {
        this._position = value
    }
    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): Map {
        if (!json) {

            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }
        if (json.municipality !== undefined) {
            this.municipality = json.municipality
        }
        if (json.state !== undefined) {
            this.state = json.state
        }
        if (json.benign !== undefined) {
            this.benign = json.benign
        }
       
        if (json.malignant !== undefined) {
            this.malignant = json.malignant
        }
        if (json.in_analysis !== undefined) {
            this.in_analysis = json.in_analysis
        }
        if (json.forms_count !== undefined) {
            this.forms_count = json.forms_count
        }
        if (json.position !== undefined) {
            this.position = json.position
        }
        return this
    }
    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {
        return {
            municipality: this.municipality || undefined,
            state: this.state || undefined,
            benign: this.benign || undefined,
            malignant: this.malignant || undefined,
            in_analysis: this.in_analysis || undefined,
            forms_count: this.forms_count || undefined,
            position: this.position || undefined
        }
    }
}